import {
  type UseGraphicsFieldsControllerOptions,
  useGraphicsFieldsController,
} from "./GraphicsFields.controller";
import { GraphicsFieldsPresentation } from "./GraphicsFields.pres";

export type GraphicsFieldsProps = UseGraphicsFieldsControllerOptions;

export const GraphicsFields = (props: GraphicsFieldsProps) => {
  const controller = useGraphicsFieldsController(props);

  return <GraphicsFieldsPresentation {...controller} />;
};
